import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Image, Modal, Row, FormText } from "react-bootstrap";
import { useGoogleLogin } from 'react-google-login';
import { useForm } from "react-hook-form";
import { useHistory } from 'react-router-dom';
import { useToasts } from "react-toast-notifications";
import logo from '../../../assets/logo_stride.png';
import { configService } from "../../../config/configureApi";
import { AuthActionEnum, ErrorMessageEnum } from "../../../enums/app.enum";
import { useAuthState } from "../../../states/auth.state";
import { utils } from '../../../_helpers';
import SInputComponent from '../../s-input/s-input.component';
import CloseIcon from '../close-icon/close-icon.component';
import TermConditionModal from '../term-condition-modal/term-condition-modal.component';
import PrivacyPolicyModal from '../privacy-pocily-modal/privacy-pocily-modal.component';
import './login-modal.component.scss';

const GOOGLE_API_KEY = configService.googleLoginApiKey || ''

/**
 * Modal delect
 * @param {*} props Modal props
 * @param {*} props.onHide callback function when close modal
 * @param {*} props.pathto path redirect after login
 * @returns
 */
const LoginModal = (props: any) => {
  const history = useHistory();
  const authState = useAuthState();
  const { clearErrors, control, handleSubmit, setError, formState: { errors } } = useForm();
  const { addToast } = useToasts();
  const [showTC, setshowTC] = useState(false)
  const [showPrivacy, setshowPrivacy] = useState(false)
  const [showVerifyForm, setShowVerifyForm] = useState(false);
  const [verifyTimer, setVerifyTimer] = useState(0);
  const [userPhone, setUserPhone] = useState();
  const [userEmail, setUserEmail] = useState();
  const [allowCookie, setAllowCookie] = useState(false)

  const handleLoginG = (res: any) => {
    authState.loginG(res.accessToken).then(loginRes => {
      props.onHide()
      if (props.pathto) history.push(props.pathto)
    })
  }

  const { signIn } = useGoogleLogin({
    onSuccess: handleLoginG,
    onFailure: (err) => {
      if (err.details === 'Cookies are not enabled in current environment.') {
        setAllowCookie(true)
      }
    },
    clientId: GOOGLE_API_KEY,
    isSignedIn: false,
    accessType: 'offline',
  })

  const handleLoginFB = async () => {
    window.FB.login((res: any) => {
      if (!res.authResponse) {
        // console.log('login fb fail')
        addToast(ErrorMessageEnum.loginFbFail, { appearance: 'error' })
      } else {
        authState.loginFB(res.authResponse.accessToken).then(loginRes => {
          props.onHide()
          if (props.pathto) history.push(props.pathto)
        })
      }
    }, { scope: 'email,public_profile' })
  }

  const handleOpenSignup = () => {
    props.onHide(AuthActionEnum.OPEN_SIGNUP)
  }

  const handleOpenForgot = () => {
    props.onHide(AuthActionEnum.OPEN_FORGOT)
  }

  const onSubmit = (formData: any) => {
    authState.login(formData.username, formData.password)
      .then(res => {
        if (res.data.message === 'openOTP') {
          setShowVerifyForm(true)
          setVerifyTimer(60)
          setUserPhone(res.data.phone)
          setUserEmail(res.data.email)
          return;
        } else {
          props.onHide()
          if (props.pathto) history.push(props.pathto)
          else {
            if (res.data.need_update == 1) {
              history.push('/user-profile-setting?action=edit')
            }
          }
        }
      }).catch(err => {
        console.log(err.response)
        clearErrors()
        setError('password', { type: 'manual', message: err.response.data?.message })
      })
  }

  const onVerifySubmit = (formData: any) => {
    authState.verifyToken({ token: formData.token }).then(res => {
      props.onHide()
      if (props.pathto) history.push(props.pathto)
      else {
        if (res.data.need_update == 1) {
          history.push('/user-profile-setting?action=edit')
        }
      }
    }).catch(err => {
      clearErrors()
      // setError('token', { type: 'manual', message: err.response.data?.message })
      addToast(err.response.data?.message || ErrorMessageEnum.otpIncorrect, {appearance: 'error'})
    })
  }

  useEffect(() => {
    let timer: any
    if (verifyTimer === 0) {
      clearInterval(timer)
      setShowVerifyForm(false)
    }
    if (verifyTimer > 0) {
      timer = setInterval(() => {
        setVerifyTimer(verifyTimer - 1);
      }, 1000);
    }
    // clearing interval
    return () => {
      if (timer) {
        clearInterval(timer)
      }
    }
  }, [verifyTimer])

  return (
    <Modal {...props} animation={false} centered>
      <Modal.Body className="text-center">
        <CloseIcon onClicked={props.onHide} />
        <Container>
          <Row>
            <Col>
              <Image src={logo} width="300" className="my-4" />
              <div>
                <p className='text-14'>
                  By entering to this website, you accept our <span className='text-primary pointer fw-7' onClick={() => setshowTC(true)}>Terms of Use </span>
                  and our <span className='text-primary pointer fw-7' onClick={() => setshowPrivacy(true)}>Privacy Policy</span>
                </p>
              </div>
              <Row>
                <Col className='px-md-5'>
                  {!showVerifyForm && (
                    <>
                      <div className="d-flex justify-content-center">
                        <div className={`btn btn-google btn-block btn-outline btn-signin`} onClick={() => {
                          if (allowCookie) {
                            addToast(ErrorMessageEnum.allowCookies, { appearance: 'warning' })
                          } else {
                            signIn()
                          }
                        }}>
                          <svg width="15" height="15" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512">
                            <path style={{ fill: '#FBBB00' }} d="M113.47,309.408L95.648,375.94l-65.139,1.378C11.042,341.211,0,299.9,0,256  c0-42.451,10.324-82.483,28.624-117.732h0.014l57.992,10.632l25.404,57.644c-5.317,15.501-8.215,32.141-8.215,49.456  C103.821,274.792,107.225,292.797,113.47,309.408z" />
                            <path style={{ fill: '#518EF8' }} d="M507.527,208.176C510.467,223.662,512,239.655,512,256c0,18.328-1.927,36.206-5.598,53.451  c-12.462,58.683-45.025,109.925-90.134,146.187l-0.014-0.014l-73.044-3.727l-10.338-64.535  c29.932-17.554,53.324-45.025,65.646-77.911h-136.89V208.176h138.887L507.527,208.176L507.527,208.176z" />
                            <path style={{ fill: '#28B446' }} d="M416.253,455.624l0.014,0.014C372.396,490.901,316.666,512,256,512  c-97.491,0-182.252-54.491-225.491-134.681l82.961-67.91c21.619,57.698,77.278,98.771,142.53,98.771  c28.047,0,54.323-7.582,76.87-20.818L416.253,455.624z" />
                            <path style={{ fill: '#F14336' }} d="M419.404,58.936l-82.933,67.896c-23.335-14.586-50.919-23.012-80.471-23.012  c-66.729,0-123.429,42.957-143.965,102.724l-83.397-68.276h-0.014C71.23,56.123,157.06,0,256,0  C318.115,0,375.068,22.126,419.404,58.936z" />
                          </svg>
                          Google</div>
                        <Button variant='primary' block className="btn-facebook btn-facebook btn-signin" onClick={handleLoginFB}>
                          <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 96.124 96.123">
                            <path style={{ fill: 'rgb(255 255 255)' }}
                              d="M72.089,0.02L59.624,0C45.62,0,36.57,9.285,36.57,23.656v10.907H24.037c-1.083,0-1.96,0.878-1.96,1.961v15.803   c0,1.083,0.878,1.96,1.96,1.96h12.533v39.876c0,1.083,0.877,1.96,1.96,1.96h16.352c1.083,0,1.96-0.878,1.96-1.96V54.287h14.654   c1.083,0,1.96-0.877,1.96-1.96l0.006-15.803c0-0.52-0.207-1.018-0.574-1.386c-0.367-0.368-0.867-0.575-1.387-0.575H56.842v-9.246   c0-4.444,1.059-6.7,6.848-6.7l8.397-0.003c1.082,0,1.959-0.878,1.959-1.96V1.98C74.046,0.899,73.17,0.022,72.089,0.02z"
                            >
                            </path>
                          </svg>
                          <span>Facebook</span>
                        </Button>
                      </div>
                      <Form className="my-4" onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className="mb-3 my-1" controlId="formBasicEmail">
                          <SInputComponent name="username" type='text' placeholder="Username" control={control} error={errors.username}
                            rules={{
                              required: { value: true, message: ErrorMessageEnum.requiredFieldMessage }
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3 my-1" controlId="formBasicPassword">
                          <SInputComponent name="password" type='password' placeholder="Password" control={control} error={errors.password}
                            rules={{
                              required: { value: true, message: ErrorMessageEnum.requiredFieldMessage },
                              validate: (val: string) => {
                                return utils.validPassword(val) || ErrorMessageEnum.invalidPassword
                              },
                            }}
                          />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicCheckboxLogin">
                          <Form.Check type="checkbox" label="Keep me signed in" />
                        </Form.Group>
                        <div className="d-grid gap-2">
                          <Button type="submit" variant="danger" size="lg" className="btn-block">Login</Button>
                        </div>
                      </Form>
                    </>
                  )}

                  {showVerifyForm && (
                    <>
                      <FormText>Please key in the One Time Verification code sent to your mobile <span className="font-weight-bold">{userPhone}</span> and email <span className="font-weight-bold">{userEmail}</span></FormText>
                      <Form className="mt-2 mb-4" onSubmit={handleSubmit(onVerifySubmit)}>
                        <Form.Group className="mb-3 my-1 position-relative" controlId="formBasicEmail">
                          <span className="verify-timer">{verifyTimer}</span>
                          <SInputComponent name="token" type='text' placeholder="Token" control={control} error={errors.token} />
                        </Form.Group>
                        <div className="d-grid gap-2">
                          <Button type="submit" variant="danger" size="lg" className="btn-block">Verify</Button>
                        </div>
                      </Form>
                    </>
                  )}
                </Col>
              </Row>
              {!showVerifyForm && (
                <div className="d-flex justify-content-between mb-4 mt-2">
                  <span className='text-primary pointer text-14 letter-86' onClick={handleOpenSignup}><b>Not a user? Sign up</b></span>
                  <span className='text-primary pointer text-14 letter-86' onClick={handleOpenForgot}><b>Forgot Password</b></span>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      {showTC && <TermConditionModal show={showTC} onHide={() => setshowTC(false)} onOk={() => setshowTC(false)} />}
      {showPrivacy && <PrivacyPolicyModal show={showPrivacy} onHide={() => setshowPrivacy(false)} onOk={() => setshowPrivacy(false)} />}
    </Modal >
  );
}

export default LoginModal;
